
import * as React from 'react';

import { useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import camelcaseKeys from "camelcase-keys";

import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';

import { GridPagination, DataGrid, GridColDef } from '@mui/x-data-grid';
import { TablePagination } from '@mui/material';
import Paper from '@mui/material/Paper';

const columns: GridColDef[] = [
  {
    field: 'fullName',
    headerName: '姓名',
    description: 'This column has a value getter.',
    sortable: true,
    width: 175,
    valueGetter: (value, row) => `(${row.sort}) ${row.chineseName}`,
  },    
  { field: 'gender', headerName: '性別', width: 125 },  
];

const paginationModel = { page: 0, pageSize: 5 };

export default function DataGrid1() {

  const { getMemberList } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const memberList = useSelector((state) => state.all.memberList);

  useEffect(() => {
    getMemberList();
  }, []);

  if (memberList.length > 0) {
    return (
      <Paper sx={{ width: '100%' }}>
        <DataGrid
          rows={memberList}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          checkboxSelection
          sx={{ border: 0 }}
        />
      </Paper>
    );
  } else {
    return null;
  }

}